import React, { useMemo, useState } from 'react';
import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { ButtonProps } from '@cp/ds/src/components/button';
import { MapProps } from './map';
import { MapPlaceholder } from './placeholder';

const name = 'LazyMap';
const Root = styled(Box, { name })({
  position: 'relative',
  overflow: 'hidden',
});

export interface LazyMapProps extends BoxProps {
  renderMap: (props?: Partial<MapProps>) => JSX.Element;
  Button: (props: ButtonProps) => JSX.Element;
}

export const LazyMap: React.FC<LazyMapProps> = ({ renderMap, Button, ...props }) => {
  const [mapOpen, setMapOpen] = useState(false);
  const map = useMemo(() => (mapOpen ? renderMap() : null), [mapOpen, renderMap]);

  return (
    <Root {...props}>
      <MapPlaceholder
        sx={{
          visibility: mapOpen ? 'hidden' : 'visible',
          position: 'absolute',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Button onClick={() => setMapOpen(true)}>Смотреть на карте</Button>
      </MapPlaceholder>
      {map}
    </Root>
  );
};
